import { API_URL } from 'app/config';
import {
  createCredentials,
  createHeaders,
  handleNotOkResponse,
  getNetworkErrorOrOriginalError,
  sendErrorToBackend,
} from 'common/utils/requestUtils';

import {
  DeviceSettings,
  DashboardData,
  Activity,
  OperationResult,
  OperationResultTypes,
  MigrationData,
} from './entitiesTypes';

export async function fetchDashboardDataRequest(
  deviceSettings: DeviceSettings
): Promise<DashboardData> {
  try {
    const res = await fetch(`${API_URL}/dashboard/prepareData`, {
      method: 'POST',
      headers: createHeaders(),
      credentials: createCredentials(),
      body: JSON.stringify(deviceSettings),
    });
    handleNotOkResponse(res);
    return (await res.json()) as DashboardData;
  } catch (error) {
    sendErrorToBackend(error);
    throw getNetworkErrorOrOriginalError(error);
  }
}

export async function updateDashboardActivityRequest(activity: Activity): Promise<OperationResult> {
  try {
    const res = await fetch(`${API_URL}/dashboard/activity`, {
      method: 'POST',
      headers: createHeaders(),
      credentials: createCredentials(),
      body: JSON.stringify(activity),
    });
    // In case a GSSO timeout happened, the response would be a text/html instead of application/json.
    // There should be no error thrown then, as it cannot be handled.
    const contentType = res.headers.get('content-type');
    if (contentType && contentType.indexOf('json') === -1) {
      return { result: OperationResultTypes.SUCCESS };
    }
    handleNotOkResponse(res);
    const result = (await res.json()) as OperationResult;
    if (result.result === OperationResultTypes.FAILED) {
      throw new Error(result.message || 'updateDashboardActivityRequest operation failed');
    }
    return result;
  } catch (error) {
    throw getNetworkErrorOrOriginalError(error);
  }
}

export async function fetchMigrationDataRequest(): Promise<MigrationData> {
  try {
    const res = await fetch(`${API_URL}/migration/prepareData`, {
      method: 'POST',
      headers: createHeaders(),
      credentials: createCredentials(),
    });
    handleNotOkResponse(res);
    return (await res.json()) as MigrationData;
  } catch (error) {
    sendErrorToBackend(error);
    throw getNetworkErrorOrOriginalError(error);
  }
}
